import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CheckIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='21'
			viewBox='0 0 20 21'
			width='20'
			{...props?.innerSvgProps}
		>
			<rect
				fill='#48428A'
				height='20'
				rx='4'
				width='20'
				y='0.5'
			/>
			<path
				clipRule='evenodd'
				d='M16.7266 5.79289C17.0911 6.18342 17.0911 6.81658 16.7266 7.20711L9.25997 15.2071C8.89548 15.5976 8.30452 15.5976 7.94003 15.2071L3.27337 10.2071C2.90888 9.81658 2.90888 9.18342 3.27337 8.79289C3.63786 8.40237 4.22881 8.40237 4.5933 8.79289L8.6 13.0858L15.4067 5.79289C15.7712 5.40237 16.3621 5.40237 16.7266 5.79289Z'
				fill='white'
				fillRule='evenodd'
			/>
		</svg>
	);
};

export default CheckIcon;
